import { render, staticRenderFns } from "./DesmatamentoArgentina2025.vue?vue&type=template&id=31ab7a52&scoped=true&lang=pug"
import script from "./DesmatamentoArgentina2025.vue?vue&type=script&lang=js"
export * from "./DesmatamentoArgentina2025.vue?vue&type=script&lang=js"
import style0 from "./DesmatamentoArgentina2025.vue?vue&type=style&index=0&id=31ab7a52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ab7a52",
  null
  
)

export default component.exports